import { Building2, ToggleRight, ToggleLeft } from "lucide-react";
import { useT, useDeptName } from "@/contexts/LanguageContext";
import { DEPT_ICONS } from "@/utils/constants";

const ResidentialDashboardView = ({ departments, onDepartmentClick, onToggleNA, clientId }) => {
  const t = useT();
  const dn = useDeptName();

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "completed": return "completed";
      case "in_progress": return "in-progress";
      default: return "not-started";
    }
  };

  return (
    <div data-testid="residential-dashboard">
      <div className="page-header">
        <h2>{t("select_residential_dept")}</h2>
        <p className="text-muted">{t("select_residential_subtitle")}</p>
      </div>
      <div className="department-grid">
        {departments.map((dept) => {
          const DeptIcon = DEPT_ICONS[dept.key] || Building2;
          const isNA = dept.not_applicable;
          return (
            <div
              key={dept.key}
              className={`department-card ${isNA ? "department-card-na" : ""}`}
              data-testid={`res-dept-card-${dept.key}`}
              style={isNA ? { opacity: 0.5 } : { cursor: "pointer" }}
              onClick={() => !isNA && onDepartmentClick(dept)}
            >
              <div className="department-card-header">
                <div className="department-card-icon">
                  <DeptIcon size={24} />
                </div>
                <div className="department-card-toggle">
                  <label className="na-toggle" onClick={(e) => e.stopPropagation()}>
                    <span className="na-label">{t("not_applicable")}</span>
                    <button
                      className="toggle-btn"
                      onClick={(e) => { e.stopPropagation(); onToggleNA(dept.key, !isNA); }}
                      data-testid={`res-toggle-na-${dept.key}`}
                    >
                      {isNA ? <ToggleRight size={24} className="toggle-on" /> : <ToggleLeft size={24} className="toggle-off" />}
                    </button>
                  </label>
                </div>
              </div>
              <h3 className="department-card-name">{dn(dept.key)}</h3>
              {!isNA && (
                <>
                  <div className="progress-bar" style={{ marginTop: "8px" }}>
                    <div
                      className={`progress-fill ${dept.status === "completed" ? "success" : dept.status === "in_progress" ? "warning" : ""}`}
                      style={{ width: `${dept.completion_percentage}%` }}
                    ></div>
                  </div>
                  <div className="department-card-footer">
                    <span className={`badge badge-${getStatusBadgeClass(dept.status)}`}>
                      {t(dept.status)}
                    </span>
                    <span className="text-muted">{Math.round(dept.completion_percentage)}%</span>
                  </div>
                </>
              )}
              {isNA && (
                <div className="department-card-footer">
                  <span className="badge badge-na">{t("not_applicable")}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResidentialDashboardView;
